module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/10-8e588f977b67206eb0e50799bdb8123a.jpg";